var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPerson = function SvgPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4865_29629",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4865_29629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62891 9.01562C8.28168 9.6684 9.06641 9.99479 9.98307 9.99479C10.8997 9.99479 11.6845 9.6684 12.3372 9.01562C12.99 8.36285 13.3164 7.57812 13.3164 6.66146C13.3164 5.74479 12.99 4.96007 12.3372 4.30729C11.6845 3.65451 10.8997 3.32812 9.98307 3.32812C9.06641 3.32812 8.28168 3.65451 7.62891 4.30729C6.97613 4.96007 6.64974 5.74479 6.64974 6.66146C6.64974 7.57812 6.97613 8.36285 7.62891 9.01562ZM3.31641 14.3281V16.6615H14.5338C14.5049 16.5549 14.492 16.4474 14.492 16.3433V14.608C14.1737 14.5379 13.8864 14.3789 13.6471 14.1395C13.3153 13.8077 13.1378 13.3837 13.1378 12.9127V11.2685C12.9894 11.2263 12.8406 11.1872 12.6914 11.151C11.8025 10.9358 10.8997 10.8281 9.98307 10.8281C9.06641 10.8281 8.16363 10.9358 7.27474 11.151C6.38585 11.3663 5.51085 11.6892 4.64974 12.1198C4.24696 12.3281 3.92405 12.6302 3.68099 13.026C3.43793 13.4219 3.31641 13.8559 3.31641 14.3281ZM13.9712 11.5389V12.9127C13.9712 13.161 14.0596 13.3735 14.2364 13.5503C14.4132 13.7271 14.6257 13.8155 14.8739 13.8155H15.3253V16.3433C15.3253 16.426 15.3479 16.4956 15.393 16.552C15.4327 16.6015 15.481 16.638 15.5379 16.6615H15.7961C15.8563 16.6368 15.9062 16.5947 15.946 16.5351L16.6497 15.5176V14.3281C16.6497 13.8559 16.5282 13.4219 16.2852 13.026C16.0421 12.6302 15.7192 12.3281 15.3164 12.1198C14.8717 11.8974 14.4233 11.7038 13.9712 11.5389Z",
    fill: "#263DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5794 16.674C15.5117 16.6515 15.4553 16.612 15.4102 16.5556C15.365 16.4991 15.3424 16.4295 15.3424 16.3468V13.819H14.8911C14.6428 13.819 14.4303 13.7306 14.2535 13.5538C14.0767 13.377 13.9883 13.1645 13.9883 12.9162V9.30512C13.9883 9.05686 14.0767 8.84433 14.2535 8.66753C14.4303 8.49074 14.6428 8.40234 14.8911 8.40234H17.5317C17.7724 8.40234 17.9661 8.49638 18.1128 8.68446C18.2595 8.87254 18.3028 9.07943 18.2426 9.30512L17.5994 11.5621H18.1072C18.378 11.5621 18.5793 11.6824 18.7109 11.9232C18.8426 12.1639 18.8294 12.3971 18.6714 12.6228L15.9631 16.5386C15.918 16.6063 15.8597 16.6515 15.7882 16.674C15.7167 16.6966 15.6471 16.6966 15.5794 16.674Z",
    fill: "#263DBA"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person.54efaae9.svg";
export { ForwardRef as ReactComponent };